export enum RoutePath {
  NewOrder = "/newOrder",
  EditOrder = "/editOrder",
  SplitOrder = "/splitOrder",
  ConfirmQuantities = "/confirmQuantities",
  ConfirmDeliveryDate = "/confirmDeliveryDate",
  BookTimeSlot = "/bookTimeSlot",
  InboundDeliveries = "/inboundDeliveries",
  InboundDelivery = "/inboundDelivery",
  OutboundDeliveries = "/outboundDeliveries",
  NewOutboundDelivery = "/outboundDeliveries/new",
  Stocks = "/stocks",
  Home = "/home",
}
